<template>
  <el-dialog
      ref="singleTableRef"
      v-model="dialogVisible"
      :show-header="false"
      title=""
      top="30px"
      width="1000px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="false"
      class="school-table"
      :before-close="handleClose">
    <!--      头部-->
    <template #header>
      <div class="border-bottom border-2 border-primary py-2 fw-bold text-center mb-2 position-relative text-secondary">
        {{ currentRow ? currentRow.Name : "选择所属大学，一旦保存不能修改，请谨慎选择" }}
        <div class="position-absolute end-0 bottom-0 mb-1">
          <el-button type="primary" class="" :disabled="!currentRow" @click="choise(true)">选好了,关闭窗口</el-button>
          <el-button type="" @click="choise(false)">取消</el-button>
        </div>

      </div>
    </template>
    <div class="dialog-item1">
      <!--      搜索框-->
      <el-form :model="queryParam" label-width="auto" style="max-width: 400px" @submit.native.prevent>
        <el-form-item label="学校名称">
          <div class="d-flex">
            <el-input  v-model="queryParam.name" placeholder="请输入学校名称" clearable @clear="getList(true)"/>
            <el-button type="" class="mx-2" :icon="Search" @click="getList(true)">搜索</el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-table
          :data="list"
          border
          @row-click="handleTableCurrentChange"
          @row-dblclick="handleTableDBclick"
          :current-row-key="currentRow"
          :highlight-current-row="true"
          style="width: 100%" height="440" v-loading="loading">
        <el-table-column label="学校名称" min-width="180px" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.Name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="省份" min-width="100px" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.Province || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="类型" >
          <template #default="scope">
            {{ scope.row.Tags || "--" }}
          </template>
        </el-table-column>
<!--        <el-table-column label="学校标识码" width="120">-->
<!--          <template #default="scope">-->
<!--            {{ scope.row.Code || "&#45;&#45;" }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="主管部门">-->
<!--          <template #default="scope">-->
<!--            {{ scope.row.Department || "&#45;&#45;" }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="所在地点">-->
<!--          <template #default="scope">-->
<!--            {{ scope.row.City || "" }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="办学层次" width="100">
          <template #default="scope">
            {{ scope.row.Level || "--" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <span class="dialog-footer">
       <el-pagination v-show="total>0"
                      layout="total, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="queryParam.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, onMounted, reactive} from 'vue';
import {getSchoolList} from "@/api/school";
import {Search} from '@element-plus/icons-vue'
const currentRow = ref()
const singleTableRef = ref()
const emits = defineEmits(['close', 'choised'])
const dialogVisible = ref(true)
import {ElMessage} from "element-plus";

const list = ref([])
const loading = ref(false)
const total = ref(10)
const queryParam = reactive({
  pageSize: 10,
  current: 1,
  name: ""
})
const handleCurrentChange = () => {
  getList()
}

// 表行被选择
const handleTableCurrentChange = (val) => {
  currentRow.value = val
}
// 表行被双击
const handleTableDBclick = (val) => {
  currentRow.value = val
  choise(true)
}
// 页码改变
const handleSizeChange = (event) => {
  if (queryParam.pageSize !== event) {
    queryParam.current = 1
    queryParam.pageSize = event
    getList()
  }
}
const props = defineProps({
  item: {
    default: {},
  }
})
// 开始
onMounted(() => {
  getList(true)
})
const getList = async (init) => {
  if(init){
    queryParam.current = 1
  }
  loading.value = true
  const res = await getSchoolList(queryParam)
  loading.value = false
  if(res.success){
    total.value = res.total
    const data = res.data || []
    list.value = data
  }else{
    ElMessage.warning("请求失败")
  }
}

const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}

// 选中
const choise = (isChoised)=>{
  if(isChoised){
    if(!currentRow.value){
      return ElMessage.warning("未选择学校")
    }
    emits("choised", currentRow.value)
  }else {
    emits("choised", null)
  }


}


</script>

<style scoped lang="scss">
.dialog-item1 {
  width: 100%;
  height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
:deep(.el-table) .table-selected-row{
  --el-table-tr-bg-color: red;
}


</style>
